module.exports = __webpack_public_path__ + "static/media/image7.f0d62ebb.png";